import { Button, Card, Flex, Segmented } from "antd";
import { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import RenderIf from "../../../components/RenderIf";
import RccDescriptions from "./Description";
import RccForm from "./Form";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../../hooks/useAuth";
import { rccService } from "../../../services/rcc.service";
import RccPaymentProofDetailContent from "./PaymentProof/DetailContent";
import { rccPaymentProofService } from "../../../services/rcc-payment-proof.service";

export default function RCCDetail(){

  const { user } = useAuth()

  const queryClient = useQueryClient()
  const navigate = useNavigate()
  
  const [currTab, setCurrTab] = useState('Task Form')
  const rccFormRef = useRef()

  const { id } = useParams()

  const { data: registration  } = useQuery({
    queryKey: ['detailRegistration', id],
    queryFn: () => rccService.getById(id),
  })

  const { data: paymentProofs } = useQuery({
    queryKey: ['paymentProofByRegistration', registration?.data?.tracking_id],
    queryFn: () => rccPaymentProofService.getAllData({ keyword: registration?.data?.tracking_id }),
    enabled: !!registration?.data?.tracking_id
  })

  const paymentProofId = paymentProofs?.data?.[0]?.id

  return (
    <>
      <Card
        title="Detail Registrasi"
        actions={[
          <Flex key={'1'} justify="end" style={{ paddingRight: 24, paddingLeft: 24 }} gap={16} >
            <Button onClick={() => navigate('/data-rcc')} variant="outlined" color="primary" style={{ marginRight: 'auto' }} >
              Kembali
            </Button>
            <Button onClick={() => rccFormRef.current.nextStep()} variant="outlined" color="primary" >
              Selanjutnya
            </Button>
          </Flex>
        ]}
        extra={
          <Segmented
            options={['Task Form', 'Data Registrasi', 'Bukti Bayar']}
            value={currTab}
            onChange={(val) => setCurrTab(val)}
          />
        }
      >
        <RenderIf when={currTab == 'Task Form'} >
          <RccForm 
            ref={rccFormRef} 
            registrationStatus={registration?.data.status}
            userSubdivision={user?.user?.subdivision}
            rejectionData={registration?.data?.rejectionData || null}
            registrationId={id}
            onSuccessVerify={() => queryClient.invalidateQueries('detailRegistration')}
          />
        </RenderIf>
        <RenderIf when={currTab == 'Data Registrasi'} >
          <RccDescriptions
            registration={registration}
            registrationId={id}
          />
        </RenderIf>
        <RenderIf when={currTab == 'Bukti Bayar'} >
          <RccPaymentProofDetailContent 
            id={paymentProofId} 
            isFromRegistration={true} 
            onActionSuccess={() => {
              queryClient.invalidateQueries(['detailRegistration', id])
              queryClient.invalidateQueries(['paymentProofByRegistration', registration?.data?.tracking_id])
            }}
          />
        </RenderIf>
      </Card>
      
    </>
  )
}